import React, { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
import apiUrl from '../config/apiPath'
import config from '../config/config'
import moment from 'moment'

export const displayErrorString = error => {
  toast.configure({
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false
  })
  toast.error(error)
}
export const displayError = error => {
  toast.configure({
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false
  })
  if (error.response.status === 422) {
    // var row = [];
    // Object.keys(error.response.data.errors).forEach((key, i) => {
    //   row.push(error.response.data.errors[key][0]);
    // })
    // const Msg = ({ closeToast, toastProps }) => (
    //   row.map((char, i) => {
    //     return (
    //       <li>
    //         {char}
    //       </li>
    //     );
    //   })
    // )
    toast.error(error.response.data.message)
  } else if (error.response.status === 400 || error.response.status === 401) {
    toast.error(error.response.data.message)
  } else {
    toast.error(error.message)
  }
}
export const displaySuccess = success => {
  toast.configure({
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false
  })
  toast.success(success)
}
export const getUsers = async (
  limit = '',
  skip = '',
  search = '',
  sort = ''
) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(
      path +
        '/get-users?limit=' +
        limit +
        '&skip=' +
        skip +
        '&search=' +
        search +
        '&sort=' +
        sort,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getPhyios = async (limit = '', skip = '') => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/get-physios?limit=' + limit + '&skip=' + skip, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getPhyioKyc = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/view-physio-kyc/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getCoupons = async (limit = '', skip = '') => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/get-coupons?limit=' + limit + '&skip=' + skip, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getCouponById = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/coupon-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const exportPhysio = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/export-verified-physios', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const exportUnverifiedPhysio = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/export-unverified-physios', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const exportUser = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/export-users', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const dashCounts = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/dashboard', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getSpecialties = async (limit = '', skip = '') => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/get-specialties?limit=' + limit + '&skip=' + skip, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getInterests = async (limit = '', skip = '') => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/get-interests?limit=' + limit + '&skip=' + skip, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getPredefinedMessages = async (limit = '', skip = '') => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/predefined-message?limit=' + limit + '&skip=' + skip, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getSpecialtyById = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/specialty-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getInterestById = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/interest-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getPredefinedMsgById = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/predefined-message-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getAllTransactions = async (limit = '', skip = '') => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  console.log(token)
  var response_final = await axios
    .get(path + '/all-transactions?limit=' + limit + '&skip=' + skip, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getBookings = async (
  limit = '',
  skip = '',
  user_id = '',
  physio_id = '',
  booking_status = 'all',
  from_date = '',
  to_date = ''
) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(
      path + `/all-bookings`,
      {
        limit: limit,
        skip: skip,
        user_id: user_id,
        physio_id: physio_id,
        booking_status: booking_status,
        from_date:
          from_date == moment(new Date()).format('YYYY-MM-DD') ? '' : from_date,
        to_date:
          to_date == moment(new Date()).format('YYYY-MM-DD') ? '' : to_date
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getCancelBooking = async (limit = '', skip = '') => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/cancelled-bookings', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getRefund = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/refund-payment/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getVerifiedPhyios = async (
  limit = '',
  skip = '',
  search = '',
  banStatus = '',
  role = '',
  sort = ''
) => {
  const data = {
    // + limit + "&offset=" + skip + "&search=" + search
    limit: limit,
    offset: skip,
    sort: sort, //asc, desc
    search: search,
    is_banned: banStatus, //true, false, ""
    doctor_interest: role
  }
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/get-verified-physios', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getRequestedPhysioList = async (count, page) => {
  const data = {
    page: page,
    count: count
  }
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/nri/provider-requests', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getReviewsList = async (count, page) => {
  const data = {
    page: page,
    count: count
  }
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/nri/negative-provider-ratings', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getPositiveReviews = async (count, page) => {
  const data = {
    page: page,
    count: count
  }
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/nri/positive-provider-ratings', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getUnverifiedPhyios = async (
  limit = '',
  skip = '',
  search = '',
  kycStatus = '',
  banStatus = '',
  role = '',
  sort = ''
) => {
  const data = {
    limit: limit,
    offset: skip,
    sort: sort, //asc, desc
    kyc: kycStatus,
    search: search,
    is_banned: banStatus, //true, false, ""
    doctor_interest: role
  }
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/get-unverified-physios', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getUserDetail = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/user-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const updateReview = async (payload) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
   const data = {
    user_id: payload.user_id,
    rating_id: payload.rating_id,
    provider_id: payload.provider_id,
    nri_booking_id: payload.nri_booking_id,
    nri_booking_slot_id: payload.nri_booking_slot_id,
    rating: payload.rating, 
    review: payload.review,
    politeness: payload.politeness,
    time_management: payload.time_management,
    skills: payload.skills,
    is_recommended: payload.is_recommended
  }
  var response_final = await axios
    .post(path + '/nri/update-provider-rating', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getPhysioDetail = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/physio-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getEscrowList = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/escrow-list/previous-week', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getEscrowDetail = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/physio-escrow-sessions/previous-week/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}
export const getEscrowDetailForecast = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/physio-escrow-sessions/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getEscrowForecast = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + '/escrow-list', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getInterestsDropdown = async () => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/get-interests', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getReportedUsers = async (
  limit = '',
  skip = '',
  search = '',
  sort = ''
) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  const data = {
    limit: limit,
    skip: skip,
    search: search,
    sort: sort
  }
  var response_final = await axios
    .post(path + '/reported-users', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getReportedPhysio = async (
  limit = '',
  skip = '',
  search = '',
  sort = ''
) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  const data = {
    limit: limit,
    skip: skip,
    search: search,
    sort: sort
  }
  var r
  var response_final = await axios
    .post(path + '/reported-doctors', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const reportAction = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/action-taken/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const sessionList = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/booking-sessions/` + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      console.log(response, 'lpl')
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const walletPhysioList = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/wallet/physios-list`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getProviderWallets = async (
  limit = '',
  skip = '',
  user_id = []
) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(
      path + `/physio-wallets`,
      {
        limit: limit,
        skip: skip,
        user_ids: user_id
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const WalletTransactions = async (id, limit, skip) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/wallet-transactions/${id}?limit=${limit}&skip=${skip}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const physioPayouts = async (limit, skip, status) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(
      path + `/physio-payouts?limit=${limit}&skip=${skip}&status=${status}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getAllTickets = async (page, perPage, sort, status) => {
  let path = config.walletService
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(
      path +
        `/tickets?page=${page}&per_page=${perPage}&sort=created_at.${sort}&status=${status}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const ticketResolved = async id => {
  let path = config.walletService
  var token = localStorage.getItem('token')
  var data = {
    status: 'resolved'
  }
  var response_final = await axios
    .patch(path + `/tickets/` + id, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getAdmins = async (count, page) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  const data = {
    count: count,
    page: page
  }
  var response_final = await axios
    .post(path + `/admins-list`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getAdminDetail = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/admin-details/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}
export const deleteAdmin = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/delete-admin/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const authme = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/authme`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getNriInterest = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/nri/get-interests`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getNriProviders = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/nri/providers-list`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getNriDetails = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/nri/provider-details/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getNriBookings = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/nri/all-bookings`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}
export const sendReminder = async (bookingId, providerId,slot_id) => {
  let path = config.siteUrl
  const data = {
    booking_id: bookingId,
    booking_slot_id: slot_id,
    provider_id: providerId,
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/nri/remind-to-rate-provider`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getProviderByInterest = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/nri/get-providers-by-interest/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getCouponList = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/nri/get-coupons`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}
export const getFaqList = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/nri/faqs-list`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}
export const editFaq = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/nri/edit-faq/` + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getNriCouponById = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/nri/coupon-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getNriBookingById = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/nri/booking-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const removeSlots = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/nri/delete-booking-slot/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getNriUsers = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/nri/users-list`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const dashCountsNri = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/nri/dashboard', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getMedicalList = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/nri/get-interest-conditions', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getNriUserDetails = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/nri/user-details/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getHospitalAdmins = async (count, page) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  const data = {
    count: count,
    page: page
  }
  var response_final = await axios
    .post(path + `/get-hospital-admins`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getHospitalProviders = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/hospital/providers-list`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getHospitalDetails = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/hospital/provider-details/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getSurveys = async (count, page, search) => {
  const data = {
    count: count,
    page: page,
    search: search
  }
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/hospital/survey-list`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getSurveyDetail = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/hospital/survey-details/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const exportSurvey = async data => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + '/hospital/export-survey-list', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      return []
    })
  return response_final
}

export const getChannelPartners = async (count, page) => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  const data = {
    count: count,
    page: page
  }
  var response_final = await axios
    .post(path + `/get-channel-partners`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getChannelProviders = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/channel-partner/providers-list`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getChannelDetails = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/channel-partner/provider-details/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getChannelPartnerDropdown = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/get-channel-partners-dropdown`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getChannelBookings = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/channel-partner/assigned-bookings`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getChannelProviderDropdown = async id => {
  let path = config.siteUrl
  var token = localStorage.getItem('token')
  var response_final = await axios
    .get(path + `/channel-partner/providers-dropdown-list`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getProviderEarning = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/channel-partner/provider-earnings`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}

export const getReschedules = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/nri/reschedule-requests`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}
export const getPendingReviewList = async (count, page) => {
  let path = config.siteUrl
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token')
  var response_final = await axios
    .post(path + `/nri/pending-rating-sessions`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(function (response) {
      return response.data.data
    })
    .catch(function (error) {
      console.log(error, 'perrroorrr')
      return []
    })
  return response_final
}
